import { MonoTypeOperatorFunction } from 'rxjs';
import { applyErrorHandler } from './apply-error-handler';
import { catchAndRethrow } from './catch-and-rethrow';
import { selectErrorHandler } from './select-error-handler';

export const handleSpecificErrors = <T>(handlers: Record<string, unknown>): MonoTypeOperatorFunction<T> =>
  catchAndRethrow((err: unknown) => {
    const handler = selectErrorHandler(handlers, err, false);
    return applyErrorHandler(handler);
  });
